import { useMemo } from 'react';

import { useTestTrack } from './useTestTrack';

export interface FeatureFlagConfig {
  splitName: string;
  context: string;
  trueVariant?: string;
}

export const useFeatureFlag = ({ splitName, context, trueVariant }: FeatureFlagConfig) => {
  const testTrack = useTestTrack();

  return useMemo(() => {
    if (!testTrack) {
      return { loading: true, enabled: false };
    }

    return {
      loading: false,
      enabled: testTrack.ab(splitName, { context, trueVariant }),
    };
  }, [testTrack, splitName, context, trueVariant]);
};
